export const de = {
    translation: {
        b: {
            cancel: 'Abbrechen',
            confirm: 'Bestätigen',
            send: 'Senden',
            done: 'Fertig',
            close: 'Schließen',
            clear: 'Leeren',
            copy_link: 'Link kopieren',
            export: 'Exportieren',
            delete: 'Löschen',
            delete_confirm: 'Löschen bestätigen',
            duplicate: 'Duplizieren',
            share: 'Teilen',
            sign_in: 'Anmelden',
            sign_up: 'Registrieren',
            email_address: 'E-Mail-Adresse',
            yes: 'Ja',
            no: 'Nein'
        },
        m_languages: {
            title: 'Sprachen',
            subtitle: 'Sprache wählen'
        },
        m_feedback: {
            feature: {
                name: 'Feature-Anfragen', // Funktionswunsch
                desc: 'Fehlt Ihnen eine Funktion? Sagen Sie es uns — Ihre Ideen zählen'
            },
            feedback: {
                name: 'Feedback',
                desc: 'Ihr Feedback bedeutet uns viel — hinterlassen Sie eine kurze Nachricht'
            }
        },
        m_feedback_t: {
            feature: {
                name: 'Danke für Ihren Vorschlag!',
                desc: 'Wir schätzen es sehr, dass Sie sich die Zeit nehmen, Ihre Gedanken zu teilen — das hilft uns, besser zu werden.'
            },
            feedback: {
                name: 'Danke für Ihr Feedback!',
                desc: 'Wir schätzen es sehr, dass Sie sich die Zeit nehmen, Ihre Gedanken zu teilen — das hilft uns, besser zu werden.'
            }
        },
        m_diagram_details: {
            name_place: 'Projektnamen eingeben',
            desc_place: 'Projektbeschreibung eingeben'
        },
        m_quick_share: {
            title: 'Schnelles Teilen',
            subtitle: '(Teilen per Link)'
        },
        m_export_img: {
            title: 'Bild exportieren'
        },
        m_export_code: {
            title: 'Code {{db_engine}} exportieren',
            download_file: 'Datei herunterladen',
            copy_code: 'Code kopieren'
        },
        m_sign_in_remind: {
            title: 'Danke, dass Sie DB Design ausprobieren',
            subtitle: 'Melden Sie sich an oder registrieren Sie sich, um das Limit für die Anzahl der Tabellen zu erhöhen, Diagramme zu speichern und weitere Funktionen freizuschalten.'
        },
        m_sign_in_restrict: {
            title: 'Melden Sie sich an, um mehr in der App zu machen',
            subtitle: 'Melden Sie sich an oder registrieren Sie sich, um Tabellengrenzen zu erhöhen, Diagramme zu speichern und weitere Funktionen freizuschalten.'
        },
        m_new_diagram: {
            title: 'Neues Diagramm',
            subtitle: 'Datenbank-Engine auswählen',
            open_diagram: 'Diagramm öffnen'
        },
        m_keyboard_shortcuts: {
            title: 'Tastenkürzel',
            ctrl_left: {
                title1: 'Bedienelemente',
                title2: '(Links)',
                items: {
                    mouse_sel: 'Mausauswahl / Handmodus',
                    table: 'Tabelle',
                    line: 'Linie',
                    area: 'Bereich',
                    note: 'Notiz',
                    comment: 'Kommentar',
                    pen: 'Stift',
                    undo: 'Rückgängig',
                    redo: 'Wiederholen'
                }
            },
            ctrl_top_left: {
                title1: 'Bedienelemente',
                title2: '(Oben links)',
                items: {
                    export_img: 'Bild exportieren',
                    search: 'Suchen',
                    editor_panel: 'Editorbereich'
                }
            },
            ctrl_bottom_right: {
                title1: 'Bedienelemente',
                title2: '(Unten rechts)',
                items: {
                    minimap: 'Minikarte',
                    zoom_in: 'Vergrößern',
                    zoom_out: 'Verkleinern',
                    zoom_100: 'Zoom auf 100 %'
                }
            },
            ctx_tab: {
                title1: 'Kontextmenü',
                title2: '(Tabelle)',
                items: {
                    dupl_tab: 'Tabelle duplizieren',
                    del_tab: 'Tabelle löschen'
                }
            },
            ctx_del_tab: {
                title1: 'Kontextmenü',
                title2: '(Tabelle löschen)',
                items: {
                    yes: 'Ja',
                    no: 'Nein'
                }
            },
            ctx_tab_col: {
                title1: 'Kontextmenü',
                title2: '(Tabellenspalte)',
                items: {
                    add_col_below: 'Neue Spalte darunter hinzufügen',
                    focus_col_above: 'Fokus auf die Spalte darüber',
                    focus_col_below: 'Fokus auf die Spalte darunter',
                    move_col_up: 'Spalte nach oben verschieben',
                    move_col_down: 'Spalte nach unten verschieben',
                    dupl_col: 'Spalte duplizieren',
                    del_col: 'Spalte löschen'
                }
            },
            ctx_line: {
                title1: 'Kontextmenü',
                title2: '(Linie)',
                items: {
                    del_line: 'Linie löschen'
                }
            },
            ctx_area: {
                title1: 'Kontextmenü',
                title2: '(Bereich)',
                items: {
                    dupl_area: 'Bereich duplizieren',
                    del_area: 'Bereich löschen'
                }
            },
            ctx_multi: {
                title1: 'Kontextmenü',
                title2: '(Mehrfachauswahl)',
                items: {
                    select_all: 'Alle Elemente auswählen',
                    create_area_for_select_els: 'Bereich für ausgewählte Elemente erstellen',
                    dupl_select_els: 'Ausgewählte Elemente duplizieren',
                    del_select_els: 'Ausgewählte Elemente löschen'
                }
            }
        },
        t: {
            ctrl_left: {
                mouse_select: 'Mausauswahl',
                table: 'Tabelle',
                line: 'Linie',
                area: 'Bereich',
                note: 'Notiz (bald)',
                comment: 'Kommentar (bald)',
                pen: 'Stift',
                undo: 'Rückgängig',
                redo: 'Wiederholen'
            },
            ctrl_top_left: {
                logo: 'Hinweis: Dies ist eine Testumgebung',
                name: 'Diagramminformationen',
                editor: 'Editor (bald)',
                search: 'Suche (bald)',
                export: 'Exportoptionen',
                view_mode: 'Ansichtsmodus',
                zoom_to_fit: 'An Bildschirm anpassen'
            },
            ctrl_top_right: {
                feature_req: 'Feature-Anfragen', // Funktionswunsch
                sign_in: 'Anmelden',
                quick_share: 'Schnelles Teilen'
            },
            ctrl_bottom_right: {
                full_screen: 'Vollbild',
                minimap: 'Minikarte',
                zoom_out: 'Verkleinern',
                zoom_100: 'Zoom auf 100 %',
                zoom_in: 'Vergrößern',
                info: 'Informationen & Ressourcen'
            },
            ctx: {
                base: {
                    colors: {
                        default: 'Standard',
                        blue: 'Blau',
                        green: 'Grün',
                        red: 'Rot',
                        purple: 'Lila',
                        violet: 'Violett'
                    },
                    borders: {
                        none: 'Keine',
                        solid: 'Durchgezogen',
                        dashed: 'Gestrichelt',
                        dotted: 'Gepunktet'
                    },
                    color: 'Farbe',
                    border: 'Rahmen',
                    description: 'Beschreibung',
                    description_table_place: 'Beschreibung der Tabelle',
                    description_column_place: 'Beschreibung der Spalte',
                    description_line_place: 'Beschreibung der Linie',
                    description_note_place: 'Beschreibung der Notiz',
                    description_area_place: 'Beschreibung des Bereichs',
                    description_pen_place: 'Beschreibung des Pfads',
                    hide_menu: 'Menü ausblenden',
                    show_menu: 'Menü einblenden'
                },
                tab_col: {
                    add_col_below: 'Spalte darunter hinzufügen',
                    add_col_above: 'Spalte darüber hinzufügen',
                    key: 'Key',
                    keys: {
                        none: 'Keine',
                        pk: 'Primary Key',
                        fk: 'Foreign Key'
                    },
                    index: 'Index',
                    indexes: {
                        none: 'Kein',
                        regular: 'Regular',
                        unique: 'Unique',
                        full_text: 'Full Text'
                    },
                    increment: 'Auto Increment',
                    enum: 'Enum',
                    enum_place: 'enum1, enum2',
                    not_null: 'Not Null',
                    default_value: 'Default Value',
                    default_value_place: 'default_value',
                    generated_value: 'Generated Value',
                    generated_value_place: 'column * 12',
                    check: 'Check',
                    check_place: 'column >= 3 AND column <= 100',
                    move_col_down: 'Spalte nach unten verschieben',
                    move_col_up: 'Spalte nach oben verschieben',
                    more_functions: 'Weitere Funktionen'
                },
                line: {
                    change_connects: 'Verbinder ändern',
                    connects: {
                        empty: 'Leer',
                        one_to: 'One To',
                        many_to: 'Many To',
                        one_null_to: 'One / Null To',
                        many_null_to: 'Many / Null To'
                    },
                    on_update: 'On Update',
                    on_delete: 'On Delete'
                },
                area: {
                    filter: 'Elemente filtern'
                },
                multi: {
                    filter: 'Auswahl filtern',
                    create_area: 'Bereich erstellen'
                }
            }
        },
        dropdown_ctrl_view_modes: {
            full: 'Vollständig',      // коротка альтернатива: 'Komplett'
            keys_only: 'Nur Schlüssel',
            names_only: 'Nur Namen'
        },
        dropdown_ctrl_export: {
            export_img: 'Bild exportieren',
            export_code: 'SQL-Code exportieren'
        },
        dropdown_ctrl_settings: {
            sign_in: 'Anmelden',
            new_project: 'Neues Projekt',
            keyboard_shortcuts: 'Tastenkürzel',
            languages: 'Sprachen'
        },
        dropdown_ctrl_info_resources: {
            feedback: 'Feedback',
            keyboard_shortcuts: 'Tastenkürzel',
            languages: 'Sprachen',
            homepage: 'Startseite'
        },
        n: {
            default: 'Wird geladen…',
            file_ready_to_download: 'Die Datei ist zum Herunterladen bereit',
            code_copied: 'Der Code wurde kopiert',
            link_copied: 'Der Link wurde kopiert',
            please_enter_message: 'Bitte geben Sie eine Nachricht ein',
            invalid_email: 'Die E-Mail-Adresse ist ungültig',
            something_wrong_contact: 'Etwas ist schiefgelaufen. Bitte laden Sie die Seite neu oder kontaktieren Sie uns.',
            something_wrong: 'Etwas ist schiefgelaufen. Bitte laden Sie die Seite neu.',
            sending: 'Senden…',
            request_sent: 'Die Anfrage wurde gesendet. Vielen Dank!'
        }
    }
};

export const deMeta = {
    lang_origin: 'Deutsch',
    lang_eng: 'German',
    lang_code: 'de',
};
